import {gql} from 'apollo-angular';


export const markAsReadMutation = gql`
    mutation MarkAsReadMutation($dossierVersions: [DossierVersionInput]!) {
        markAsRead (dossierVersions: $dossierVersions)
    }
`;

export const markAsUnreadMutation = gql`
    mutation MarkAsUnreadMutation($dossierVersions: [DossierVersionInput]!) {
        markAsUnread (dossierVersions: $dossierVersions)
    }
`;
